import {
  START_SOFTSKILLS_USER_COURSE,
  START_SOFTSKILLS_USER_COURSE_SUCCESS,
  START_SOFTSKILLS_USER_COURSE_CLEAN,
  START_SOFTSKILLS_USER_COURSE_ERROR,
} from "./actionTypes"

const initialState = {
  error: "",
  loading: false,
  done: false,
  course: undefined,
}

const SoftskillsUserCourseStart = (state = initialState, action) => {
  switch (action.type) {
    case START_SOFTSKILLS_USER_COURSE:
      state = {
        ...state,
        loading: true,
      }
      break
    case START_SOFTSKILLS_USER_COURSE_SUCCESS:
      state = {
        ...state,
        course: action.payload.course,
        loading: false,
        done: true,
      }
      break
    case START_SOFTSKILLS_USER_COURSE_CLEAN:
      state = initialState
      break
    case START_SOFTSKILLS_USER_COURSE_ERROR:
      state = { ...state, error: action.payload, loading: false, done: false }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default SoftskillsUserCourseStart
